import { render } from "./Radiology.vue?vue&type=template&id=7cbb4c08"
import script from "./Radiology.vue?vue&type=script&lang=ts"
export * from "./Radiology.vue?vue&type=script&lang=ts"
script.render = render

export default script